/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Terms_Import_Csv_TitleInputs */



/**
* | output |
* | --- |
* | "Import terms from CSV" |
*
* @param {Knp_Terms_Import_Csv_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_terms_import_csv_title = /** @type {((inputs?: Knp_Terms_Import_Csv_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Terms_Import_Csv_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Importer des termes depuis un CSV")
	if (locale === "de") return /** @type {LocalizedString} */ ("Begriffe aus CSV importieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Importa termini da CSV")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Импорт терминов из CSV-файла")
	if (locale === "es") return /** @type {LocalizedString} */ ("Importar términos desde CSV")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("从 CSV 文件导入条款")
	if (locale === "ja") return /** @type {LocalizedString} */ ("CSVから用語をインポートする")
	if (locale === "hi") return /** @type {LocalizedString} */ ("CSV से शर्तें आयात करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Importar termos de um arquivo CSV")
	return /** @type {LocalizedString} */ ("Import terms from CSV")
});